<template>
  <div class="home_index" ref="home_index">
    作品列表
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import API from "../api";
import axios from "axios";
export default {
  name: "",
  components: {
  },
  data() {
    return {
      username: "",
    };
  },
  computed: {
     
  },
  mounted() {
   this.getBanner();
  },
  
  methods: {
    
    //获取广告图
    async getBanner(){
      const res = await API.getBannerList();
      console.log(res)
      // if(res.data.code === 444){
      //   //console.log(res.data.data)
      //   window.location.href = res.data.data
      // }else if (res.data.code === 200) {
      //   this.bannerData = res.data.data.list;
      //   //console.log(this.bannerData)
      // } else {
      //   Toast(res.data.message);
      // }
    },
  }
};
</script>



// WEBPACK FOOTER //
// activity.vue?f3a2e4a0